
import React from 'react';
import { FooterTop, FooterLinks, FooterBottom } from './footer';

const Footer = () => {
  return (
    <footer className="bg-brand-offwhite py-16">
      <div className="container mx-auto px-4 md:px-6">
        <FooterTop />
        <FooterLinks />
        <FooterBottom />
      </div>
    </footer>
  );
};

export default Footer;
